module.exports = __webpack_public_path__ + "img/217.cf077221.png";